// Tooltip.tsx
import React from 'react';
import './Tooltip.css'; // Import the new CSS file

interface TooltipProps {
  text: string;
  isVisible: boolean;
}

const Tooltip: React.FC<TooltipProps> = ({ text, isVisible }) => {
  return isVisible ? (
    <div className="tooltip sticky-note">
      <div className="tooltip-content">{text}</div>
    </div>
  ) : null;
};

export default Tooltip;
